import { render, staticRenderFns } from "./Drill1.vue?vue&type=template&id=445eac6c&scoped=true&lang=pug&"
import script from "./Drill1.vue?vue&type=script&lang=ts&"
export * from "./Drill1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445eac6c",
  null
  
)

export default component.exports